import {
	CUSTOM_ELEMENTS_SCHEMA,
	NgModule
} from '@angular/core';
import {
	CommonModule
} from '@angular/common';
import {
	DevComponent
} from './dev.component';
import {
	LoadingIconModule,
	SmartadminModule,
	SmartadminDatatableModule,
	SharedAngularComponentsAvlaModule,
	SmartadminValidationModule,
	SmartadminInputModule
} from 'shared-angular-components-avla';

@NgModule({
	imports: [
		CommonModule,
		SmartadminModule,
		SmartadminDatatableModule,
		SmartadminValidationModule,
		SmartadminInputModule,
		LoadingIconModule,
		SharedAngularComponentsAvlaModule.forRoot()
	],
	declarations: [DevComponent],
	exports: [DevComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DevModule { }
